import * as React from "react";
import { Button } from "../Button";
export class Body extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-popup-message__body" },
            React.createElement("div", { className: "rj-popup-message__body-content" },
                this.props.html && React.createElement("div", { className: "rj-popup-message__body-html", "data-uat": "popup-message", dangerouslySetInnerHTML: { __html: this.props.html } }),
                this.props.children,
                React.createElement("div", { className: "rj-popup-message__body-buttons", "data-uat": "popup-message-body-buttons" }, Object.keys(this.props.actions).map((buttonKey, i) => (React.createElement(Button, Object.assign({ key: `${buttonKey}-${i}`, uat: `button-popup-message-${buttonKey}` }, this.props.actions[buttonKey]))))))));
    }
}
//# sourceMappingURL=Body.js.map